import React, { createContext, useState, useContext, useEffect, useCallback } from 'react';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [kullanici, setKullanici] = useState(null);
  const [token, setToken] = useState(localStorage.getItem('token'));
  const [loading, setLoading] = useState(true);
  const [isSystemLocked, setIsSystemLocked] = useState(false);

  const API_URL = process.env.REACT_APP_API_URL || '/api';

  const checkLockStatus = useCallback(async () => {
    try {
      const res = await fetch(`${API_URL}/sitesettings/lock-status`);
      if (res.ok) {
        const data = await res.json();
        setIsSystemLocked(data.isLocked);
      }
    } catch (e) { /* ignore */ }
  }, []);

  useEffect(() => {
    const checkAuth = async () => {
      const storedToken = localStorage.getItem('token');
      if (storedToken) {
        try {
          const response = await fetch(`${API_URL}/auth/me`, {
            headers: { 'Authorization': `Bearer ${storedToken}` }
          });
          if (response.ok) {
            const data = await response.json();
            if (data.basarili) {
              setKullanici(data);
              setToken(storedToken);
            } else {
              logout();
            }
          } else {
            logout();
          }
        } catch {
          logout();
        }
      }
      setLoading(false);
    };
    checkAuth();
    checkLockStatus();
    const interval = setInterval(checkLockStatus, 30000);
    return () => clearInterval(interval);
  }, [checkLockStatus]);

  const login = async (kullaniciAdi, sifre) => {
    try {
      console.log('Login isteği gönderiliyor:', `${API_URL}/auth/login`);
      const response = await fetch(`${API_URL}/auth/login`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ kullaniciAdi, sifre })
      });
      
      if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        console.error('Login hatası:', response.status, errorData);
        return { success: false, message: errorData.mesaj || `Sunucu hatası: ${response.status}` };
      }

      const data = await response.json();
      if (data.basarili) {
        localStorage.setItem('token', data.token);
        setToken(data.token);
        setKullanici(data);
        return { success: true, rol: data.rol };
      }
      return { success: false, message: data.mesaj };
    } catch (error) {
      return { success: false, message: 'Bağlantı hatası!' };
    }
  };

  const logout = () => {
    localStorage.removeItem('token');
    setToken(null);
    setKullanici(null);
  };

  const isAuthenticated = !!token && !!kullanici;
  const rol = kullanici?.rol;

  const canOperate = !isSystemLocked || rol === 'Admin' || rol === 'Kasa';

  return (
    <AuthContext.Provider value={{ kullanici, token, login, logout, isAuthenticated, rol, loading, isSystemLocked, checkLockStatus, canOperate }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
